/*
 Message component
 url match: /dashboard
 Base component for the home page, redirects to appropriate 
 components depending on the URL/Route
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { messageStyles } from '../../../Styles/chatStyles';
import clsx from 'clsx';
import { ReactSVG } from 'react-svg';
import Images from '../../../Theme/Images';
import { format } from 'timeago.js';
import FileUpload from './FileUpload';
import ChatFeedback from './ChatFeedback';
import BooleanInput from './BooleanInput';
import SelectOptions from './SelectOptions';
import styled, { keyframes } from 'styled-components';
import { fadeIn } from 'react-animations';
import Loader from 'react-loader-spinner'

const bounceInAnim = keyframes`${fadeIn}`;

const SystemMessage = styled.div`
  animation: 1s ${bounceInAnim};
`;

const CustomerMessage = styled.div`
  animation: 1s ${bounceInAnim};
`;
@inject('chatStore')
@observer
class Message extends React.Component {

    renderBoolean = (row) => {
        const { classes, index } = this.props;
        return (
            <BooleanInput row={row} index={index} focusInput={this.focusInput} />
        )
    }

    renderFeedback = (row) => {
        const { classes, index } = this.props;
        return (
            <ChatFeedback row={row} index={index} focusInput={this.focusInput} />
        )
    }

    renderFileUpload = (row) => {
        const { classes, index } = this.props;
        return (
            <FileUpload row={row} index={index} focusInput={this.focusInput} />
        )
    }

    renderSelectOptions = (row) => {
        const { classes, index } = this.props;
        return (
            <SelectOptions row={row} index={index} focusInput={this.focusInput} />

        )
    }

    focusInput = () => {
        let elem = document.getElementById("textInput")
        if (elem) {
            elem.focus()
        }
    }

    renderIcon = (from, index) => {
        const { classes } = this.props;
        const { chatData } = this.props.chatStore;
        if (index + 1 < chatData.messages.length) {
            if (chatData.messages[index + 1].messageBy === from)
                return (<ReactSVG className={classes.hidden} src={Images[`${from.toLowerCase()}`]} />)
            else
                return (<ReactSVG src={Images[`${from.toLowerCase()}`]} />)
        }
        else
            return (<ReactSVG src={Images[`${from.toLowerCase()}`]} />)
    }

    getLinkedText = (matches, text) => {
        let temp = text
        matches && matches.length && matches.map((row) => {
            temp = temp.replace(row, `<a target="_blank" href=${row}>${row}</a>`)
        })
        return temp
    }

    getMessageText = (text) => {
        var expression = /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/gi;
        var matches = text.match(expression);
        return <span dangerouslySetInnerHTML={{ __html: this.getLinkedText(matches, text) }}></span>
    }

    renderMessage = () => {
        const { classes, row, index } = this.props
        return (

            row.messageType === 'SELECT_OPTIONS' ?
                this.renderSelectOptions(row) :
                row.messageType === 'FILE_UPLOAD' ? this.renderFileUpload(row) :
                    row.messageType === 'FEEDBACK' ? this.renderFeedback(row) :
                        row.messageType === 'BOOLEAN' ? this.renderBoolean(row) :
                            <div className={clsx({ [classes.textMessage]: true, [classes.agent]: row.messageBy === 'CUSTOMER' })} >
                                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{this.getMessageText(row.messageText)}
                                </span>
                                {
                                    row.sending !== undefined && row.sending ?
                                        <div className={clsx({ [classes.timeStamp]: true, [classes.agTimeStamp]: row.messageBy === 'CUSTOMER' })} >
                                            <ReactSVG src={Images.chatSending} />&nbsp;&nbsp;<div>Sending</div>
                                        </div>
                                        :
                                        <div className={clsx({ [classes.timeStamp]: true, [classes.agTimeStamp]: row.messageBy === 'CUSTOMER' })} >
                                            <ReactSVG src={Images.doubleTick} />&nbsp;&nbsp;<div> {format(row.createdAt)}</div>
                                        </div>
                                }
                            </div>

        )
    }

    render() {
        const { classes, row, index, theme } = this.props;
        const { chatData, typing } = this.props.chatStore
        return (
            row.messageBy !== 'CUSTOMER' ?
                <SystemMessage className={row.messageBy !== 'CUSTOMER' ? classes.left : classes.right} >
                    {/*row.messageBy !== 'CUSTOMER' ? this.renderIcon(row.messageBy, index) : null*/}
                    {this.renderMessage()}
                    {/*row.messageBy === 'CUSTOMER' ? this.renderIcon(row.messageBy, index) : null*/}
                </SystemMessage>
                :
                <div className={row.messageBy !== 'CUSTOMER' ? classes.left : classes.right} >
                    {/*row.messageBy !== 'CUSTOMER' ? this.renderIcon(row.messageBy, index) : null*/}
                    {this.renderMessage()}
                    {/*row.messageBy === 'CUSTOMER' ? this.renderIcon(row.messageBy, index) : null*/}
                </div>
        )

    }
}
export default withStyles(messageStyles, { withTheme: true })(withRouter(Message));
